import {
  Button,
} from '@material-ui/core';
import {
  getAchievements,
  getCertifications,
  getCodingSkills,
  getHobbies,
  getSkillsLanguage,
  getSoftSkills,
  getSoftwareSkills,
  getStudentSkillsPro,
  getTrainings,
  getTransports,
  getWorkExperience,
} from '@webapps/business';
import {
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useState } from 'react';

import DropdownSection from '../../profil/Components/CVGenerator/DropdownSection';
import DropdownSectionNested from '../../profil/Components/CVGenerator/DropdownSectionNested';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    widthScreen: window.innerWidth,
    heightScreen: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        widthScreen: window.innerWidth,
        heightScreen: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    // Cleanup pour éviter les fuites mémoire
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

const getWindowsSize = () => {
  const { widthScreen, heightScreen } = useWindowSize();
  return { widthScreen, heightScreen };
};

const percentageThemeChoise = 0.15;
const percentageSettings = 0.2;
const percentageContent = 1 - percentageThemeChoise - percentageSettings;

const Settings = ({
  setOptions,
  colors,
  options,
  setColorSelected,
  colorSelected,
  isLoading,
  setIsLoading,
  handleGeneratePDFWithNode,
  isLoadingDownloadCv,
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const htmlStaticStyle = {
    mergeStyle: (...styles) => {
      return styles.reduce((acc, style) => {
        return { ...acc, ...style };
      }, {});
    },
    colorBox: (color) => {
      return ({
        backgroundColor: color.color,
        width: '20px',
        height: '20px',
        borderRadius: '6px',
        border: colorSelected === color ? '3px solid black' : '1px solid #ccc',
        cursor: 'pointer'
      })
    },
    titleSettingSidebar: {
      fontFamily: 'Montserrat',
      color: '#152652',
      lineHeight: '100%',
      fontWeight: 600,
      fontSize: '15px', // 15px
      '@media only screen and (max-width: 1543px)': { fontSize: '14.5px' }, // 14.5px
      '@media only screen and (max-width: 1279px)': { fontSize: '14px' }, // 14px
      '@media only screen and (max-width: 810px)': { fontSize: '13.5px' }, // 13.5px
      '@media only screen and (max-width: 390px)': { fontSize: '13px' }, // 13px
      margin: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: 'all 0.2s',
    },
    sectionSidebar: {
      margin: "20px",
    },
    colorChoiceContainer: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
    },
    dropdownIcon: {
      cursor: 'pointer',
    },
    containerChoiseInSettingSidebar: {
      display: 'flex',
      flexDirection: 'column',
    },
    subTitleSettingSidebar: {
      fontFamily: 'Roboto',
      color: '#5D75A8',
      fontWeight: 400,
      fontSize: '14px', // 15px
      '@media only screen and (max-width: 1543px)': { fontSize: '13.5px' },
      '@media only screen and (max-width: 1279px)': { fontSize: '13px' },
      '@media only screen and (max-width: 810px)': { fontSize: '12.5px' },
      '@media only screen and (max-width: 390px)': { fontSize: '12px' },
    },
  };

  const { idUser: id } = useAuth();

  const { data: transports = [], isLoading: isLoadingTransports } = useQuery(getTransports, {
    key: 'moyensTransportCv',
    variables: { id },
  });

  const { data: skillsLanguage = [], isLoading: isSkillsLanguageLoading } = useQuery(getSkillsLanguage, {
    key: 'skillsLanguage',
    variables: { id },
  });

  const { data: hobbies = [], isLoading: isHobbiesLoading } = useQuery(getHobbies, {
    key: 'hobbies',
    variables: { id },
  });

  const { data: softSkills = [], isLoading: isSoftSkillsLoading } = useQuery(getSoftSkills, {
    key: 'softSkills',
    variables: { id },
  });

  const { data: softwareSkills = [], isLoading: isSoftwareSkillsLoading } = useQuery(getSoftwareSkills, {
    key: 'softwareSkills',
    variables: { id },
  });

  const { data: codingSkills = [], isLoading: isCodingSkillsLoading } = useQuery(getCodingSkills, {
    key: 'codingSkills',
    variables: { id },
  });

  const { data: trainings = [], isLoading: isTrainingsLoading } = useQuery(getTrainings, {
    key: 'trainings',
    variables: { id },
  });

  const { data: certifications = [], isLoading: isCertificationsLoading } = useQuery(getCertifications, {
    key: 'certifications',
    variables: { id },
  });

  const { data: achievements = [], isLoading: isAchievementsLoading } = useQuery(getAchievements, {
    key: 'achievements',
    variables: { id },
  });

  const { data: workExperiences = [], isLoading: isWorkExperiencesLoading } = useQuery(getWorkExperience, {
    key: 'workExperiences',
    variables: { id },
  });

  const {
    data: skillsPro = [], isLoading: isSkillsProLoading } = useQuery(getStudentSkillsPro, {
      key: 'skillsPerso',
      variables: { id },
    });

  const unique = [...new Set(skillsPro?.map((item) => item.category.label))];

  const newL = unique?.map((obj) => ({
    label: obj,
    skills: skillsPro?.filter(({ category }) => category.label === obj),
  }));

  useEffect(() => {
    if (
      isSkillsLanguageLoading ||
      isHobbiesLoading ||
      isSoftSkillsLoading ||
      isSoftwareSkillsLoading ||
      isCodingSkillsLoading ||
      isTrainingsLoading ||
      isCertificationsLoading ||
      isAchievementsLoading ||
      isSkillsProLoading ||
      isWorkExperiencesLoading ||
      isLoadingTransports
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [
    isSkillsLanguageLoading,
    isHobbiesLoading,
    isSoftSkillsLoading,
    isSoftwareSkillsLoading,
    isCodingSkillsLoading,
    isTrainingsLoading,
    isCertificationsLoading,
    isAchievementsLoading,
    isSkillsProLoading,
    isWorkExperiencesLoading,
    isLoadingTransports,
  ]);

  const handleOptionSelection = (key, object) => {
    setOptions((prevOptions) => {
      const selected = prevOptions[key];
      if (selected.includes(object)) {
        return { ...prevOptions, [key]: selected.filter((item) => item !== object) };
      } else {
        return { ...prevOptions, [key]: [...selected, object] };
      }
    });
  };

  useEffect(() => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      trainingsSelected: trainings.length > 0 && trainings.slice(0, 3),
      skillsLanguageSelected: skillsLanguage.length > 0 && skillsLanguage.slice(0, 3),
      softSkillsSelected: softSkills.length > 0 && softSkills.slice(0, 5),
      hobbiesSelected: hobbies.length > 0 && hobbies.slice(0, 4),
      softwareSkillsSelected: softwareSkills.length > 0 && softwareSkills.slice(0, 5),
      codingSkillsSelected: codingSkills.length > 0 && codingSkills.slice(0, 5),
      certificationsSelected: certifications.length > 0 && certifications.slice(0, 3),
      achievementsSelected: achievements.length > 0 && achievements.slice(0, 3),
      workExperiencesSelected: workExperiences.length > 0 && workExperiences.slice(0, 3),
      skillsProSelected: skillsPro.length > 0 && skillsPro.slice(0, 6),
      transportsSelected: transports.length > 0 && transports,
    }));
  }, [isLoading]);

  return (
    <div className={classes.settingsContainer}>
      <Button
        color="primary"
        variant='contained'
        disabled={isLoadingDownloadCv}
        onClick={() => handleGeneratePDFWithNode()}
        className={classes.downloadButton}
      >
        Télécharger le PDF
      </Button>
      <div style={htmlStaticStyle.mergeStyle(htmlStaticStyle.sectionSidebar, {
        marginTop: '0px'
      })}>
        <p style={htmlStaticStyle.titleSettingSidebar} className={css({ marginBottom: '15px !important' })}>Choisissez une couleur</p>
        <div style={htmlStaticStyle.colorChoiceContainer}>
          {colors.map((color, index) => (
            <div
              key={index}
              onClick={() => setColorSelected(color.name)}
              style={htmlStaticStyle.colorBox(color)}
            ></div>
          ))}
        </div>
      </div>
      <hr style={{ margin: "0" }} color='#C0D9FF' />
      {workExperiences.length > 0 && (
        <DropdownSection
          title={'Expériences Professionnelles'}
          htmlStaticStyle={htmlStaticStyle}
          data={workExperiences}
          handleChange={(object) => handleOptionSelection('workExperiencesSelected', object)}
          dataSelected={options?.workExperiencesSelected}
        />
      )}
      {trainings.length > 0 && (
        <DropdownSection
          title={'Formations'}
          htmlStaticStyle={htmlStaticStyle}
          data={trainings}
          handleChange={(object) => handleOptionSelection('trainingsSelected', object)}
          dataSelected={options?.trainingsSelected}
        />
      )}
      {certifications.length > 0 && (
        <DropdownSection
          title={'Certifications'}
          htmlStaticStyle={htmlStaticStyle}
          data={certifications}
          handleChange={(object) => handleOptionSelection('certificationsSelected', object)}
          dataSelected={options?.certificationsSelected}
        />
      )}

      {newL.length > 0 && (
        <DropdownSectionNested
          title="Compétences pro."
          htmlStaticStyle={htmlStaticStyle}
          data={newL}
          handleChange={(object) => handleOptionSelection('skillsProSelected', object)}
          dataSelected={options?.skillsProSelected}
        />
      )}
      {softSkills.length > 0 && (
        <DropdownSection
          title={'Compétences perso'}
          htmlStaticStyle={htmlStaticStyle}
          data={softSkills}
          handleChange={(object) => handleOptionSelection('softSkillsSelected', object)}
          dataSelected={options?.softSkillsSelected}
        />
      )}
      {skillsLanguage.length > 0 && (
        <DropdownSection
          title={'Langues'}
          htmlStaticStyle={htmlStaticStyle}
          data={skillsLanguage}
          handleChange={(object) => handleOptionSelection('skillsLanguageSelected', object)}
          dataSelected={options?.skillsLanguageSelected}
        />
      )}
      {softwareSkills.length > 0 && (
        <DropdownSection
          title={'Logiciel'}
          htmlStaticStyle={htmlStaticStyle}
          data={softwareSkills}
          handleChange={(object) => handleOptionSelection('softwareSkillsSelected', object)}
          dataSelected={options?.softwareSkillsSelected}
        />
      )}
      {codingSkills.length > 0 && (
        <DropdownSection
          title={'Langages de Programmation'}
          htmlStaticStyle={htmlStaticStyle}
          data={codingSkills}
          handleChange={(object) => handleOptionSelection('codingSkillsSelected', object)}
          dataSelected={options?.codingSkillsSelected}
        />
      )}
      {hobbies.length > 0 && (
        <DropdownSection
          title={'Centres d\'intérêt'}
          htmlStaticStyle={htmlStaticStyle}
          data={hobbies}
          handleChange={(object) => handleOptionSelection('hobbiesSelected', object)}
          dataSelected={options?.hobbiesSelected}
        />
      )}
      {achievements.length > 0 && (
        <DropdownSection
          title={'Réalisations'}
          htmlStaticStyle={htmlStaticStyle}
          data={achievements}
          handleChange={(object) => handleOptionSelection('achievementsSelected', object)}
          dataSelected={options?.achievementsSelected}
        />
      )}
      {transports.length > 0 && (
        <DropdownSection
          title={'Moyens de transport'}
          htmlStaticStyle={htmlStaticStyle}
          data={transports}
          handleChange={(object) => handleOptionSelection('transportsSelected', object)}
          dataSelected={options?.transportsSelected}
          displayDivider={false}
        />
      )}
    </div>
  );
};

const styles = () => ({
  themeCoiceContainer: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: '10px',
    backgroundColor: '#F3F7FF',


    width: getWindowsSize().widthScreen * percentageThemeChoise,
    height: '100%',
    overflowY: 'scroll'
  },
  themes: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  titleThemeContainer: {
    marginTop: '20px',
    // marginLeft: '15px',
    marginBottom: '20px',
  },
  settingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'scroll',
    // gap: '20px',
    // padding: '20px',
    backgroundColor: '#F3F7FF',
    width: getWindowsSize().widthScreen * percentageSettings,
  },
  cvContainer: {
    overflowY: 'scroll',
    width: getWindowsSize().widthScreen * percentageContent,
    // backgroundColor: 'blue'
  },
  downloadButton: {
    width: 'calc(100% - 40px)', // 20px de margin * 2
    margin: "20px",
    marginTop: "30px"
  },
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',

  },
  containerAbsolute: {
    alignItems: 'center',
    display: 'flex',
    margin: '20px 0px',
    flexDirection: 'column',
    gap: '20px',
  },
});

export default Settings;